<div style="height: 260px; background-color: var(--gray-50); width: 100%; margin-top: -48px;">
    <p class="ex1">{{infoText}}</p>
</div>

<div style=" background-color: var(--navy-100); margin: auto;  margin-top: 20px; width: 50%;">

    <div style="height: 200px; width: 50%;float: left; text-align: center;">
        <a [routerLink]="['/home']" style="text-decoration: none;">
            <img height="150" src="assets/img/graph.png">
            <p class="ex2">{{'TOP.DASHBOARDS' | translate}}</p>
        </a>
    </div>

    <div style="height: 200px; width: 50%; float: right; text-align: center;">
        <a routerLink="/csv-list/{{initialService}}" style="text-decoration: none;">

            <img height="150" src="assets/img/tables.jpg">
            <p class="ex2">{{'TOP.SERVICES' | translate}}</p>
        </a>
    </div>
</div>